import React, { useState } from "react";
import Header from "../../headerone/Main";
import Breadcrumb from "../../Breadcrumb/Main";
import { Container, Row } from "react-bootstrap";
import NewsList2025 from "./NewsList2025";
import NewsList2024 from "./NewsList2024";
import NewsList2023 from "./NewsList2023";
import NewsList2022 from "./NewsList2022";
import NewsList2021 from "./NewsList2021";
import NewsList2020 from "./NewsList2020";
import NewsList2019 from "./NewsList2019";
import NewsList2018 from "./NewsList2018";
import NewsList2017 from "./NewsList2017";

export function News({ NewsList = [] }) {
    return (
        <div>
            <table class="table table-bordered mb-40">
                <tbody>
                    {NewsList.map((event, index) => (
                        <tr key={index}>
                            <td
                                style={{
                                    textAlign: "left",
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",
                                }}
                            >
                                {/* <i
                                    className="icon fal fas fa-caret-right pl-5"
                                    style={{
                                        display: "block",
                                        alignSelf: "flex-start",
                                        marginTop: "0.31lh",
                                    }}
                                /> */}

                                <div className="date" style={{
                                    backgroundColor: "#ff7350",
                                    minWidth: "120px",
                                    maxWidth: "120px",
                                    minHeight: "67px",
                                    maxHeight: "67px",
                                    color: "white",
                                    textAlign: "center",
                                    fontSize: "12px",
                                    fontFamily: "Jost, sans-serif",
                                    padding: "0",
                                    margin: "0",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis"
                                }}>
                                    <strong style={{ display: "block", fontSize: "24px", marginTop: "10px" }}>{event.dt}</strong>
                                    {event.my}
                                </div>

                                <a
                                    href={event.link}
                                    target="_blank"
                                    rel="noreferrer"
                                    className="c-right ml-40"
                                >
                                    {/* <b className="ml-40">
                                        {event.title}
                                    </b> */}
                                    <div className="ml-40">
                                        <b>{event.title}</b>
                                    </div>
                                    <div className="ml-40">
                                        {event.desc}
                                    </div>
                                </a>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    )
}

function Main() {
    const [activeIndex, setActiveIndex] = useState(0);
    const handleClick = (index) => {
        setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
    }
    const faqData = [
         {
            id: "2025",
            name: "2025 - News",
            element: <News NewsList={NewsList2025} />
        },

        {
            id: "2024",
            name: "2024 - News",
            element: <News NewsList={NewsList2024} />
        },

        {
            id: "2023",
            name: "2023 - News",
            element: <News NewsList={NewsList2023} />
        },
        {
            id: "2022",
            name: "2022 - News",
            element: <News NewsList={NewsList2022} />
        },
        {
            id: "2021",
            name: "2021 - News",
            element: <News NewsList={NewsList2021} />
        },
        {
            id: "2020",
            name: "2020 - News",
            element: <News NewsList={NewsList2020} />
        }, 
        {
            id: "2019",
            name: "2019 - News",
            element: <News NewsList={NewsList2019} />
        },
        {
            id: "2018",
            name: "2018 - News",
            element: <News NewsList={NewsList2018} />
        },
        {
            id: "2017",
            name: "2017 - News",
            element: <News NewsList={NewsList2017} />
        }
    ]

    return (
        <>
            <Header />
            <Breadcrumb title="Home" subtitle="News" bgImage="url(/assets/img/BreadCrumCustom/ImageFaculty.jpg)" />
            <section className="project-detail">
                <Container>
                    <Row>
                        <div className="c-heading mb-5">
                            <h1>News</h1>
                        </div>

                        <div
                            className="col-lg-12 col-md-12 text-center wow fadeInUp animated"
                            data-animation="fadeInUp"
                            data-delay=".4s"
                        >
                            <div
                                className="faq-wrap pl-30 wow fadeInUp animated"
                                data-animation="fadeInUp"
                                data-delay=".4s"
                            >
                                <div
                                    className="accordion"
                                    id="accordionExample"
                                >
                                    {faqData.map((item, index) => (
                                        <div className="card" key={index}>
                                            <div
                                                className="card-header"
                                                id={item.id}
                                            >
                                                <h2 className="mb-0">
                                                    <button
                                                        className={`faq-btn${activeIndex ===
                                                            index
                                                            ? ""
                                                            : " collapsed"
                                                            }`}
                                                        type="button"
                                                        data-bs-toggle="collapse"
                                                        data-bs-target={`#collapse${index}`}
                                                        onClick={() =>
                                                            handleClick(index)
                                                        }
                                                    >
                                                        {item.name}
                                                    </button>
                                                </h2>
                                            </div>
                                            <div
                                                id={`collapse${index}`}
                                                className={`collapse${activeIndex === index
                                                    ? " show"
                                                    : ""
                                                    } lower-content`}
                                                data-bs-parent="#accordionExample"
                                            >
                                                <div className="card-body">
                                                    {item.element}
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </Row>
                </Container>
            </section>
        </>
    )
}

export default Main;